<template>
  <div class="review">
    <h3 class="review-header">身份认证</h3>
    <div class="review-body">
        <div class="body-title">注册成为Fwatch开发者</div>
        <el-form ref="reviewForm" :rules="rules" :model="reviewForm" label-width="0px">
            <div class="idtype">
                <div :class="['idtype-item', reviewForm.idtype == 0? 'active': '']" @click="reviewForm.idtype = 0">
                    <img src="@/assets/icon-people.png">
                    <span>个人开发者</span>
                </div>
                <div :class="['idtype-item', reviewForm.idtype == 1? 'active': '']" @click="reviewForm.idtype = 1">
                    <img src="@/assets/icon_company.png">
                    <span>企业开发者</span>
                </div>
            </div>
            <el-form-item
              prop="company"
              v-if="reviewForm.idtype == 1"
              :key="'company'"
              :rules="[
                  {required: true, message: '公司名不能为空', trigger: 'blur'},
                  { max: 30, message: '长度不得超过30个字符', trigger: 'blur' }
                ]"
            >
                <el-input v-model="reviewForm.company" placeholder="请输入公司名称"></el-input>
            </el-form-item>
            <el-form-item prop="name">
                <el-input v-model="reviewForm.name" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <div class="upload-container">
                <el-upload
                    name="idup"
                    class="avatar-uploader"
                    action=""
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    :http-request="uploadImage">
                    <img v-if="img_idup" :src="img_idup" class="avatar">
                    <template v-else>
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div class="el-upload__text">添加身份证正面(国徽面)</div>
                    </template>
                </el-upload>
                <el-upload
                    name="iddown"
                    class="avatar-uploader"
                    action=""
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    :http-request="uploadImage">
                    <img v-if="img_iddown" :src="img_iddown" class="avatar">
                    <template v-else>
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div class="el-upload__text">添加身份证反面(信息面)</div>
                    </template>
                </el-upload>
            </div>
            <div class="upload-container" v-if="reviewForm.idtype == 1">
                <el-upload
                    name="license"
                    class="avatar-uploader"
                    action=""
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    :http-request="uploadImage">
                    <img v-if="img_license" :src="img_license" class="avatar">
                    <template v-else>
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div class="el-upload__text">添加营业执照</div>
                    </template>
                </el-upload>
            </div>
            <el-form-item prop="email">
                <el-input v-model="reviewForm.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>
            <el-form-item prop="phone">
                <el-input v-model.number="reviewForm.phone" placeholder="请输入手机号码"></el-input>
            </el-form-item>
            <button type="button" @click="handleSubmit">提交认证</button>
        </el-form>
    </div>
  </div>
</template>

<script>
import { idReview } from '@/api/user'
export default {
  name: 'Home',
  components: {
  },
  data() {
    var isEmail = (rule, value, callback) => {
        if (!(/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(value))) {
          callback(new Error('请输入正确的邮箱号!'));
        } else {
          callback();
        }
    }
    return {
      img_idup: '',
      img_iddown: '',
      img_license: '',
      reviewForm: {
        idtype: 0,
        company: '',
        name: '',
        email: '',
        phone: '',
        id_up: null,
        id_down: null,
        license: null
      },
      rules: {
        name: [{required: true, message: '请输入真实姓名', trigger: 'blur'}],
        email: [
            {required: true, message: '请输入邮箱', trigger: 'blur'},
            { validator: isEmail, trigger: 'blur' }
        ],
        phone: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            {type: 'number',min: 10000000000, max: 99999999999, message: '请输入11位数字'}
        ]
      }
    }
  },
  methods: {
    uploadImage(info) {
        let img = URL.createObjectURL(info.file)
        switch (info.filename) {
            case 'idup':
                this.img_idup = img
                this.reviewForm.id_up = info.file
                break;
            case 'iddown':
                this.img_iddown = img
                this.reviewForm.id_down = info.file
                break;
            case 'license':
                this.img_license = img
                this.reviewForm.license = info.file
                break;
        }
    },
    beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG&&!isPNG) {
            this.$message.error('上传头像图片只能是 JPG或png 格式!');
        }
        if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return (isJPG||isPNG) && isLt2M;
    },
    handleSubmit(){
        this.$refs.reviewForm.validate(valid => {
            if (valid) {
                let data =new FormData()
                data.append('idtype', this.reviewForm.idtype)
                data.append('company', this.reviewForm.company)
                data.append('name', this.reviewForm.name)
                data.append('email', this.reviewForm.email)
                data.append('phone', this.reviewForm.phone)
                data.append('id_up', this.reviewForm.id_up)
                data.append('id_down', this.reviewForm.id_down)
                data.append('license', this.reviewForm.license)
                idReview(data).then(()=>{
                    this.$store.commit('SET_CHECKSTEP', 1)
                    this.$router.push({path: '/reviewable', replace: true})
                })
            }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.review{
    width: 40vw;
    max-width: 900px;
    min-width: 800px;
    margin: 0 auto;
    .review-header{
        text-align: left;
        font-size: 24px;
        margin-bottom: 30px;
        margin-top: 50px;
    }
    .review-body{
        padding: 100px 180px;
        background: #FFFFFF;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
        .body-title{
            text-align: left;
            color: #333;
            font-size: 18px;
            margin-bottom: 40px;
        }
        .idtype{
            display: flex;
            margin-bottom: 20px;
            .idtype-item{
                display: flex;
                align-items: center;
                box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
                padding: 12px 14px;
                margin-left: 18px;
                &:first-child{
                    margin-left: 0;
                }
                &.active{
                    border: 4px solid #2E60DC;
                }
            }
        }
        button{
            background-color: #2E60DC;
            width: 100%;
            border: none;
            color: #fff;
            font-size: 16px;
            padding: 14px 0;
            &:focus{outline:0;}
        }
    }
}
</style>
<style lang="scss">
.review{
    .upload-container{
        display: flex;
        margin-bottom: 20px;
        .avatar-uploader{
            margin-left: 18px;
            &:first-child{
                margin-left:0;
            }
            .el-upload__text{
                font-size: 14px;
                color: #999;
                margin-bottom: 12px;
            }
        }
        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 200px;
            height: 90px;
            line-height: 90px;
            text-align: center;
        }
        .avatar {
            width: 202px;
            height: 123px;
            display: block;
        }
    }
}
</style>
